// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";

var workTime = 25 * 1;

var shortBreakTime = 5 * 1;

var longBreakTime = 10 * 1;

function reducer(resetTo, state, action) {
  switch (action) {
    case /* Start */0 :
        return {
                isRunning: true,
                seconds: state.seconds
              };
    case /* Stop */1 :
        return {
                isRunning: false,
                seconds: state.seconds
              };
    case /* Reset */2 :
        return {
                isRunning: state.isRunning,
                seconds: resetTo
              };
    case /* Tick */3 :
        var match = state.isRunning;
        var match$1 = state.seconds > 0;
        if (match && match$1) {
          return {
                  isRunning: state.isRunning,
                  seconds: state.seconds - 1 | 0
                };
        } else {
          return state;
        }
    
  }
}

function useTimer(onDone, initialTime) {
  var match = React.useReducer((function (param, param$1) {
          return reducer(initialTime, param, param$1);
        }), {
        isRunning: false,
        seconds: initialTime
      });
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function () {
          var timer = setInterval((function (param) {
                  return Curry._1(dispatch, /* Tick */3);
                }), 1000);
          return (function (param) {
                    clearInterval(timer);
                    
                  });
        }), [dispatch]);
  React.useEffect((function () {
          if (state.seconds <= 0 && onDone !== undefined) {
            Curry._1(onDone, undefined);
          }
          
        }), [
        state,
        onDone
      ]);
  return {
          isRunning: state.isRunning,
          seconds: state.seconds,
          dispatch: dispatch
        };
}

var mins = 1;

export {
  mins ,
  workTime ,
  shortBreakTime ,
  longBreakTime ,
  reducer ,
  useTimer ,
  
}
/* react Not a pure module */
